import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionComponent {
  idProyecto
  idNomina
  dispersion
  nomina

  constructor ($state) {
    this.$state = $state
  }

  $onInit () {
    if (this.dispersion.tipos_pago.length) {
      this.$state.go('nominas.detalladoNomina.dispersion.pagos', {
        id_tipo_pago: this.dispersion.tipos_pago[0].id_tipo_pago,
      })
    }
  }

  status (statusPagado) {
    this.nomina.data.status_pagado = statusPagado
    this.dispersion.status_pagado = statusPagado
  }
}

module.component('nominasNominaDispersion', {
  controller: NominasNominaDispersionComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    dispersion: '<',
  },
  require: {
    nomina: '^nomina',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/component.js